export const estacionamientos = [
    {
        nombre: 'Salida Escala',
        piid: 7451,
        img:'assets/img/ic-e-naranja.png'
    },
    {
        nombre: 'Salida Oriente',
        piid: 7452,
        img:'assets/img/ic-e-verde.png'
    },
    {
        nombre: 'Salida Sur',
        piid: 7453,
        img:'assets/img/ic-e-rosa.png'
    },
    {
        nombre: 'Salida G.Avenida',
        piid: 7455,
        img:'assets/img/ic-e-amarillo.png'
    },
    {
        nombre: 'Salida Lider',
        piid: 7454,
        img:'assets/img/ic-e-azul.png'
    }
];